import React from 'react'
// components
import ApiClients from 'components/PageComponents/Settings/Api/ApiClients'
import ApiSettingsContent from 'components/PageComponents/Settings/Api/ApiTokens/components/Content'
import CreateApiClientButton from 'components/CTAs/CreateApiClient'
// context
import { ApiClientsPageContext } from 'containers/ApiClients/layers/API'

interface Props {
  tab: number
  setTab: (value: number) => void
}

const ApiClientsTab: React.FC<Props> = ({ tab, setTab }) => {
  const { isLoading } = React.useContext(ApiClientsPageContext)

  const handleSetTab = (_: React.SyntheticEvent, value: number) => setTab(value)

  return (
    <ApiSettingsContent tab={tab} onTabChange={handleSetTab} isLoading={isLoading} cta={<CreateApiClientButton />}>
      <ApiClients />
    </ApiSettingsContent>
  )
}

export default ApiClientsTab
